import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const MasterKeySetupSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5 mb-[20px]">
      <div className="col-span-2">
        <SettingCardSkeleton
          titleWidth={150}
          controls={["input", "input", "input"]}
          showFooter
        />
      </div>
    </div>
  );
});

MasterKeySetupSkeleton.displayName = "MasterKeySetupSkeleton";

export default MasterKeySetupSkeleton;
